// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@steiner/Overrides/Widgets/OrderConfirmation/OrderConfirmationHeader";
import Plus from "@steiner/XDL/Icons/Plus";
import Print from "@steiner/XDL/Icons/Print";
import { css } from "styled-components";

headerStyles.headerGridContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 10px;
    `,
};

headerStyles.printLink = {
    icon: {
        iconProps: {
            size: 12,
            src: Print,
        },
    },
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
    css: css`
        margin-bottom: 20px;
    `,
};

headerStyles.addToListLink = {
    icon: {
        iconProps: {
            size: 12,
            src: Plus,
        },
    },
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
};
